export function escapeCsv(value: string): string {
  let v = value;
  if (/^[=+\-@]/.test(v)) {
    v = `'${v}`;
  }
  if (/[",\r\n]/.test(v)) {
    v = `"${v.replace(/"/g, '""')}"`;
  }
  return v;
}
